<template>
	<div :class="{ open: show }" class="d-flex success-alert justify-content-center align-items-center">
		<div class="icon"></div>
		<div class="text">
			<slot></slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: "SuccessComponent",
		props: ["title", "show"],
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/scss/styles";
	@import "@/assets/scss/colors";

	.success-alert {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		height: 0px;
		display: flex;
		background-color: $light-success;
		transition: height 0.2s linear;
		overflow: hidden;
	}

	.success-alert > .text {
		color: #fff;
		font-size: 28px;
		font-weight: 300;
		position: relative;
		padding: 0 10px;
	}

	.success-alert > .text strong {
		color: #fff;
		font-size: 28px;
		font-weight: bold;
	}

	.icon {
		background-image: url("~@/assets/images/icons/check-white-big.svg");
		background-position: 50% 50%;
		display: inline-block;
		height: 5rem;
		width: 5rem;
		border-radius: 50%;
		border: 2px solid #fff;
		background-repeat: no-repeat;
		margin-right: 30px;
	}

	.open {
		height: 180px;
	}

	@media only screen and (max-width: 1024px) {
		.success-alert {
			flex-direction: column;
			transition: height 0.3s linear;
		}
		.open {
			height: 100vh;
		}
		.icon {
			display: block;
			margin-right: 0px;
			margin-bottom: 10px;
			height: 80px;
			width: 80px;
		}
		.success-alert > .text {
			font-size: 22px;
			text-align: center;
		}
		.success-alert > .text strong {
			font-size: 22px;
			text-align: center;
		}
		.card-body {
			padding: 2000px 0;
		}
	}
</style>
